import React from 'react';
import PropTypes from 'prop-types';
import {InfoTooltip} from './InfoTooltip';
import {ErrorTooltip} from './ErrorTooltip';
import './style.scss';

const ALERT_TYPE = {FAIL: 'FAIL', INFO: 'INFO'};

/**
 * Tooltip Component:
 *  - Typically used to display error messages.
 */
export class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }

  onHover = (value) => () => this.setState({hover: value});

  renderTooltip = () => {
    switch (this.props.type) {
      case ALERT_TYPE.FAIL:
        return <ErrorTooltip title={this.props.title} />;
      case ALERT_TYPE.INFO:
        return <InfoTooltip title={this.props.title} />;
      default:
        return null;
    }
  };

  renderContent = () => {
    if (this.props.show) return this.renderTooltip();
    else if (this.state.hover && this.props.title) return this.renderTooltip();
    else if (this.state.hover && this.state.title) return this.renderTooltip();
    else return null;
  };

  render() {
    console.log('this.props', this.props);
    const className = `tooltip-wrap ${this.props.className}`;
    return (
      <span
        className={className}
        onMouseOver={this.onHover(true)}
        onMouseOut={this.onHover(false)}>
        {this.props.children}
        {this.renderContent()}
      </span>
    );
  }
}

Tooltip.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Child element to be displayed inside the Modal
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Title string for the Modal.
   */
  title: PropTypes.string,
  /**
   * Status of Streak Unit
   */
  type: PropTypes.oneOf([ALERT_TYPE.FAIL, ALERT_TYPE.INFO]),
  /**
   * Override for default hover behaviour
   * is show is set tooltip will always be displayed
   */
  show: PropTypes.bool,
};

Tooltip.defaultProps = {
  title: '',
  type: 'FAIL',
  show: false,
  className: '',
};
